import { nanoid } from 'nanoid';

import { createCache } from '../configs/$global';

// ---

const CACHE_KEY = 'browser-tab-id';
const $cache = createCache('getOrCreateId');

type CachedTabId = { id?: string };

function getOrCreateId(): string {
  const cachedData: CachedTabId = $cache(CACHE_KEY);

  if ('id' in cachedData && cachedData.id !== undefined) {
    return cachedData.id;
  }

  const id = nanoid();
  cachedData.id = id;

  return id;
}

export function saveBrowserTabIdListener() {
  window.addEventListener('beforeunload', () => {
    window.sessionStorage[CACHE_KEY] = getOrCreateId();

    return null;
  });
}

export function getBrowserTabId(): string {
  if (CACHE_KEY in window.sessionStorage) {
    const tabId = window.sessionStorage[CACHE_KEY];
    window.sessionStorage.removeItem(CACHE_KEY);

    const cachedData: CachedTabId = $cache(CACHE_KEY);
    cachedData.id = tabId;

    return tabId;
  }

  return getOrCreateId();
}
